<template>
  <div>
    <StoreLink
      ref="tooltipTarget"
      @keydown.enter="copyToClipBoard"
      @click="copyToClipBoard"
    >
      <IconCopy v-if="showIcon" class="mb-1 me-1" />
      <slot />
    </StoreLink>
    <BTooltip
      :model-value="showCopiedToClipboardTooltip"
      manual
      :target="tooltipTarget"
      placement="top"
    >
      {{ copyTooltipText }}
    </BTooltip>
  </div>
</template>

<script setup lang="ts">
import IconCopy from "~/components/shared/buttons/icons/IconCopy.vue";
import { BTooltip } from "bootstrap-vue-next";
import { ref } from "vue";
import StoreLink from "~/components/shared/buttons/StoreLink.vue";

const props = defineProps({
  copyText: { type: String, required: true },
  copyTooltipText: {
    type: String,
    required: false,
    default: "Copied to clipboard",
  },
  showIcon: { type: Boolean, required: false, default: true },
});

const showCopiedToClipboardTooltip = ref(false);
const tooltipTarget = ref<HTMLElement | null>(null);

let hideTooltipTimeout: ReturnType<typeof setTimeout> | null = null;

const copyToClipBoard = async () => {
  await navigator.clipboard.writeText(props.copyText);

  showCopiedToClipboardTooltip.value = true;

  if (hideTooltipTimeout) {
    clearTimeout(hideTooltipTimeout);
  }

  hideTooltipTimeout = setTimeout(() => {
    showCopiedToClipboardTooltip.value = false;
    hideTooltipTimeout = null;
  }, 1000);
};
</script>

<style scoped lang="scss">
@use "@/sass/variables.scss" as *;
</style>
